/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { PaginatedTagList } from '../model/paginatedTagList';
import { Tag } from '../model/tag';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CurrentPapCategoriesService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * View set to filter tags only for the currently active pap categories (new MŠMT framework).  Old pap category tags stay in the \&quot;pap_categories\&quot; group so historical portfolio/plan records and recommendations keep validating and rendering unchanged; new tags are additionally placed in \&quot;pap_categories_msmt\&quot; so teacher-facing pickers only ever offer the current competency set.
     * @param changedSince 
     * @param ids 
     * @param language * &#x60;af&#x60; - Afrikaans * &#x60;ar&#x60; - Arabic * &#x60;ar-dz&#x60; - Algerian Arabic * &#x60;ast&#x60; - Asturian * &#x60;az&#x60; - Azerbaijani * &#x60;bg&#x60; - Bulgarian * &#x60;be&#x60; - Belarusian * &#x60;bn&#x60; - Bengali * &#x60;br&#x60; - Breton * &#x60;bs&#x60; - Bosnian * &#x60;ca&#x60; - Catalan * &#x60;ckb&#x60; - Central Kurdish (Sorani) * &#x60;cs&#x60; - Czech * &#x60;cy&#x60; - Welsh * &#x60;da&#x60; - Danish * &#x60;de&#x60; - German * &#x60;dsb&#x60; - Lower Sorbian * &#x60;el&#x60; - Greek * &#x60;en&#x60; - English * &#x60;en-au&#x60; - Australian English * &#x60;en-gb&#x60; - British English * &#x60;eo&#x60; - Esperanto * &#x60;es&#x60; - Spanish * &#x60;es-ar&#x60; - Argentinian Spanish * &#x60;es-co&#x60; - Colombian Spanish * &#x60;es-mx&#x60; - Mexican Spanish * &#x60;es-ni&#x60; - Nicaraguan Spanish * &#x60;es-ve&#x60; - Venezuelan Spanish * &#x60;et&#x60; - Estonian * &#x60;eu&#x60; - Basque * &#x60;fa&#x60; - Persian * &#x60;fi&#x60; - Finnish * &#x60;fr&#x60; - French * &#x60;fy&#x60; - Frisian * &#x60;ga&#x60; - Irish * &#x60;gd&#x60; - Scottish Gaelic * &#x60;gl&#x60; - Galician * &#x60;he&#x60; - Hebrew * &#x60;hi&#x60; - Hindi * &#x60;hr&#x60; - Croatian * &#x60;hsb&#x60; - Upper Sorbian * &#x60;hu&#x60; - Hungarian * &#x60;hy&#x60; - Armenian * &#x60;ia&#x60; - Interlingua * &#x60;id&#x60; - Indonesian * &#x60;ig&#x60; - Igbo * &#x60;io&#x60; - Ido * &#x60;is&#x60; - Icelandic * &#x60;it&#x60; - Italian * &#x60;ja&#x60; - Japanese * &#x60;ka&#x60; - Georgian * &#x60;kab&#x60; - Kabyle * &#x60;kk&#x60; - Kazakh * &#x60;km&#x60; - Khmer * &#x60;kn&#x60; - Kannada * &#x60;ko&#x60; - Korean * &#x60;ky&#x60; - Kyrgyz * &#x60;lb&#x60; - Luxembourgish * &#x60;lt&#x60; - Lithuanian * &#x60;lv&#x60; - Latvian * &#x60;mk&#x60; - Macedonian * &#x60;ml&#x60; - Malayalam * &#x60;mn&#x60; - Mongolian * &#x60;mr&#x60; - Marathi * &#x60;ms&#x60; - Malay * &#x60;my&#x60; - Burmese * &#x60;nb&#x60; - Norwegian Bokmål * &#x60;ne&#x60; - Nepali * &#x60;nl&#x60; - Dutch * &#x60;nn&#x60; - Norwegian Nynorsk * &#x60;os&#x60; - Ossetic * &#x60;pa&#x60; - Punjabi * &#x60;pl&#x60; - Polish * &#x60;pt&#x60; - Portuguese * &#x60;pt-br&#x60; - Brazilian Portuguese * &#x60;ro&#x60; - Romanian * &#x60;ru&#x60; - Russian * &#x60;sk&#x60; - Slovak * &#x60;sl&#x60; - Slovenian * &#x60;sq&#x60; - Albanian * &#x60;sr&#x60; - Serbian * &#x60;sr-latn&#x60; - Serbian Latin * &#x60;sv&#x60; - Swedish * &#x60;sw&#x60; - Swahili * &#x60;ta&#x60; - Tamil * &#x60;te&#x60; - Telugu * &#x60;tg&#x60; - Tajik * &#x60;th&#x60; - Thai * &#x60;tk&#x60; - Turkmen * &#x60;tr&#x60; - Turkish * &#x60;tt&#x60; - Tatar * &#x60;udm&#x60; - Udmurt * &#x60;ug&#x60; - Uyghur * &#x60;uk&#x60; - Ukrainian * &#x60;ur&#x60; - Urdu * &#x60;uz&#x60; - Uzbek * &#x60;vi&#x60; - Vietnamese * &#x60;zh-hans&#x60; - Simplified Chinese * &#x60;zh-hant&#x60; - Traditional Chinese
     * @param limit Number of results to return per page.
     * @param offset The initial index from which to return the results.
     * @param parentUuid 
     * @param parentUuids Více hodnot lze oddělit čárkami.
     * @param uuid 
     * @param uuids 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public currentPapCategoriesList(changedSince?: Date, ids?: string, language?: string, limit?: number, offset?: number, parentUuid?: string, parentUuids?: Array<string>, uuid?: string, uuids?: string, observe?: 'body', reportProgress?: boolean): Observable<PaginatedTagList>;
    public currentPapCategoriesList(changedSince?: Date, ids?: string, language?: string, limit?: number, offset?: number, parentUuid?: string, parentUuids?: Array<string>, uuid?: string, uuids?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PaginatedTagList>>;
    public currentPapCategoriesList(changedSince?: Date, ids?: string, language?: string, limit?: number, offset?: number, parentUuid?: string, parentUuids?: Array<string>, uuid?: string, uuids?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PaginatedTagList>>;
    public currentPapCategoriesList(changedSince?: Date, ids?: string, language?: string, limit?: number, offset?: number, parentUuid?: string, parentUuids?: Array<string>, uuid?: string, uuids?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (changedSince !== undefined && changedSince !== null) {
            queryParameters = queryParameters.set('changed_since', <any>changedSince.toISOString());
        }
        if (ids !== undefined && ids !== null) {
            queryParameters = queryParameters.set('ids', <any>ids);
        }
        if (language !== undefined && language !== null) {
            queryParameters = queryParameters.set('language', <any>language);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (parentUuid !== undefined && parentUuid !== null) {
            queryParameters = queryParameters.set('parent__uuid', <any>parentUuid);
        }
        if (parentUuids) {
            queryParameters = queryParameters.set('parent_uuids', parentUuids.join(COLLECTION_FORMATS['csv']));
        }
        if (uuid !== undefined && uuid !== null) {
            queryParameters = queryParameters.set('uuid', <any>uuid);
        }
        if (uuids !== undefined && uuids !== null) {
            queryParameters = queryParameters.set('uuids', <any>uuids);
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<PaginatedTagList>('get',`${this.basePath}/current-pap-categories/`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * View set to filter tags only for the currently active pap categories (new MŠMT framework).  Old pap category tags stay in the \&quot;pap_categories\&quot; group so historical portfolio/plan records and recommendations keep validating and rendering unchanged; new tags are additionally placed in \&quot;pap_categories_msmt\&quot; so teacher-facing pickers only ever offer the current competency set.
     * @param id A unique integer value identifying this tag.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public currentPapCategoriesRetrieve(id: number, observe?: 'body', reportProgress?: boolean): Observable<Tag>;
    public currentPapCategoriesRetrieve(id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Tag>>;
    public currentPapCategoriesRetrieve(id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Tag>>;
    public currentPapCategoriesRetrieve(id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling currentPapCategoriesRetrieve.');
        }

        let headers = this.defaultHeaders;

        // authentication (isophi-token-auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Tag>('get',`${this.basePath}/current-pap-categories/${encodeURIComponent(String(id))}/`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
